import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyAccountPointsHistory } from '@services/useGetMyAccountPointsHistory';
import { MyAccountPointsHistory } from '@components/templates/myAccount/myAccountPointsHistory';

export function MyAccountPointsHistoryPage() {
    const { t } = useTranslation();
    const { myPoints } = useData();
    const { request: requestGetMyAccountPointsHistory } = useGetMyAccountPointsHistory();

    const translations = {
        title: t('my-points-component.metatags.title'),
        description: t('my-points-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myPoints,
        index: false,
    });

    useEffect(() => {
        requestGetMyAccountPointsHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const pointsData = (myPoints?.data ?? []).map((point) => ({
        order_uuid: point.order?.uuid ?? '',
        order_code: point.order?.code ?? '',
        purchase_value: Number(point.purchase_value),
        purchase_date: point.purchase_date ?? '',
        points_earned: point.points_earned ?? 0,
    }));

    return <MyAccountPointsHistory points={pointsData} />;
}
